import React, { useState, useEffect } from 'react';

const Banner = ({ pageName, bgimage, breadcrummbs }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100,
    });
  };

  const defaultBg = "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?q=80&w=2070&auto=format&fit=crop";

  return (
    <div
      className="relative lg:h-[200px] h-[350px] overflow-hidden group"
      onMouseMove={handleMouseMove}
    >
      {/* Animated Background with Parallax */}
      <div
        className="absolute inset-0 transform transition-transform duration-700 ease-out group-hover:scale-105"
        style={{
          backgroundImage: `url(${bgimage || defaultBg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: `${mousePosition.x}% ${mousePosition.y}%`,
          transition: 'background-position 0.3s ease-out, transform 0.7s ease-out'
        }}
      />

      {/* Dynamic Gradient Overlays */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/40 via-blue-900/30 to-indigo-900/50" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

      {/* Animated Particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white/30 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`
            }}
          />
        ))}
      </div>
      {isLoaded && (
        <div className="absolute inset-0 bg-white/10 backdrop-blur-sm" />
      )}
      <div className="relative z-10 flex flex-col items-center justify-center h-full py-8 px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-bold text-white">{pageName}</h1>
        <div className="absolute inset-0 border-2 border-transparent bg-gradient-to-r from-cyan-400/30 via-blue-400/30 to-purple-400/30 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            maskComposite: 'xor',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor'
          }} />
      </div>
    </div>
  );
};

export default Banner;